import { ConfirmationDialog } from '../Dialogs/ConfirmationDialog';
import { EditorialType, Node } from '../../domain/domain';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../reducers';
import { ComponentManagementActionType } from '../../reducers/comp.actions';

type Props = {
    onApproveEditorialContent: (node: Node, editorialType: EditorialType) => void
}

const ApproveEditorialContentDialog: React.FC<Props> = ({onApproveEditorialContent}) => {
    const open = useSelector((app: ApplicationState) => app.comp.approveEdiorialContentDialogOpen);
    const selectedEditorialType = useSelector((app: ApplicationState) => app.comp.selectedEditorialType);
    const editorNode = useSelector((app: ApplicationState) => app.comp.editorNode);
    const dispatch = useDispatch();

    if (!editorNode) {
        return <></>
    }

    return (
        <ConfirmationDialog
            open={open}
            title="Approve Editorial Content"
            contentText="Are you sure you want to approve changes to the editorial content for the current component?"
            handleNo={() => {
                dispatch({ type: ComponentManagementActionType.APPROVE_EDITORIAL_CONTENT_DIALOG_OPEN, open: false });
            }}
            handleYes={() => {
                if (selectedEditorialType) {
                    onApproveEditorialContent(editorNode, selectedEditorialType);
                    dispatch({ type: ComponentManagementActionType.APPROVE_EDITORIAL_CONTENT_DIALOG_OPEN, open: false });
                }
            }}
        />
    )
}

export default ApproveEditorialContentDialog;